/* SCUSA footer email signup -> Klaviyo client subscribe -> list XjTt35 -> Welcome flow ($10 code). */
(function () {
  "use strict";
  var COMPANY = "UHZw8t";
  var LIST = "XjTt35";
  var REVISION = "2025-01-15";
  var ENDPOINT = "https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function ready(fn){ if(document.readyState!=="loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }
  function wire(form){
    if(!form || form.getAttribute("data-scusa-wired")==="1") return;
    form.setAttribute("data-scusa-wired","1");
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var input = form.querySelector('input[type="email"], input[name="email"]');
      var btn = form.querySelector('button, input[type="submit"]');
      if(!input) return;
      var email = (input.value||"").trim();
      if(!EMAIL_RE.test(email)){ input.focus(); input.setAttribute("aria-invalid","true"); return; }
      if(form.getAttribute("data-busy")==="1") return;
      form.setAttribute("data-busy","1");
      var original = btn ? (btn.innerHTML||btn.value) : "";
      if(btn){ btn.disabled=true; if("innerHTML" in btn) btn.innerHTML="Sending…"; }
      var payload = { data:{ type:"subscription", attributes:{ custom_source:"Footer signup",
        profile:{ data:{ type:"profile", attributes:{ email:email,
          subscriptions:{ email:{ marketing:{ consent:"SUBSCRIBED" } } } } } } },
        relationships:{ list:{ data:{ type:"list", id:LIST } } } } };
      fetch(ENDPOINT,{ method:"POST", headers:{ "Content-Type":"application/json", "revision":REVISION }, body:JSON.stringify(payload) })
        .then(function(res){ if(res.status===202){ showDone(form,"Almost there — check your email to confirm and unlock your $10 code."); } else { throw new Error("status "+res.status); } })
        .catch(function(){ form.setAttribute("data-busy","0"); if(btn){ btn.disabled=false; if("innerHTML" in btn) btn.innerHTML=original; } showError(form,"Something went wrong — please try again."); });
    });
  }
  function showDone(form,msg){ var n=document.createElement("p"); n.className="ft-signup-done"; n.setAttribute("role","status"); n.style.cssText="margin:10px 0 0;font-size:13px;line-height:1.5;color:#8A9A4E;font-weight:700;"; n.textContent="✓ "+msg; form.parentNode.insertBefore(n,form.nextSibling); form.style.display="none"; }
  function showError(form,msg){ var o=form.parentNode.querySelector(".ft-signup-error"); if(o) o.remove(); var n=document.createElement("p"); n.className="ft-signup-error"; n.setAttribute("role","alert"); n.style.cssText="margin:10px 0 0;font-size:13px;line-height:1.5;color:#d9432f;font-weight:700;"; n.textContent=msg; form.parentNode.insertBefore(n,form.nextSibling); }
  ready(function(){ var form=document.getElementById("ft-signup")||document.querySelector("form.ft-signup"); wire(form); });
})();
